/* global THREE */
const pattern = new Image()
pattern.src = '/static/img/pattern.jpg'

export default class HopeStoneTexture extends THREE.Texture {
  constructor (color = 0xffffff, numLines = 1) {
    let canvas = document.createElement('canvas')
    canvas.width = canvas.height = 128

    super(canvas)
    this.canvas = canvas

    this.ctx = this.canvas.getContext('2d')

    this.magFilter = THREE.NearestFilter
    this.minFilter = THREE.NearestFilter
    this.wrapS = this.wrapT = THREE.RepeatWrapping

    this.threeColor = new THREE.Color()
    this.draw(color, numLines)
  }

  draw (color, numLines) {
    this.ctx.globalAlpha = 1
    this.ctx.globalCompositeOperation = 'source-over'
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.threeColor.set(color)
    this.ctx.fillStyle = '#' + this.threeColor.getHexString()
    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height)
    this.ctx.globalCompositeOperation = 'color-burn'
    this.ctx.drawImage(pattern, 0, 0, this.canvas.width, this.canvas.height)
    this.ctx.globalCompositeOperation = 'source-over'

    this.ctx.strokeStyle = '#ffffff'
    this.ctx.globalAlpha = 0.8
    this.ctx.lineWidth = this.canvas.height / 40
    let separation = this.ctx.lineWidth * 4

    if (numLines > 0) {
      for (let i = 0; i < numLines; i++) {
        let y = (this.ctx.lineWidth * 0.5) + (i * separation)
        this.ctx.beginPath()
        this.ctx.moveTo(0, y)
        this.ctx.lineTo(this.canvas.width, y)
        this.ctx.stroke()
      }

      this.offset.y = 0.5
      this.offset.y -= (separation * (numLines / 2)) / this.canvas.height
      this.offset.y += (separation * 0.5) / this.canvas.height
    }

    this.needsUpdate = true
  }
}



// WEBPACK FOOTER //
// ./src/atoms/HopeStoneTexture.js